import { render, staticRenderFns } from "./GroupDispute.vue?vue&type=template&id=409ff08a&scoped=true&"
import script from "./GroupDispute.vue?vue&type=script&lang=js&"
export * from "./GroupDispute.vue?vue&type=script&lang=js&"
import style0 from "./GroupDispute.vue?vue&type=style&index=0&id=409ff08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ff08a",
  null
  
)

export default component.exports